import * as React from "react";
import { CloseButton } from "../CloseButton";
export class ErrorMessage extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-pulse-bet-markets__error-message" },
            React.createElement("span", { className: "rj-pulse-bet-markets__error-message-text", dangerouslySetInnerHTML: { __html: this.props.error.message } }),
            React.createElement(CloseButton, { handler: this.props.error.handler })));
    }
}
//# sourceMappingURL=ErrorMessage.js.map